<template>
    <div class="zl-vertify-box zl-vertify-status-base">
        <div class="zl-vertify-bg"></div>
        <div class="zl-vertify-text" onselectstart="return false">向右拖动滑块</div>
        <div class="zl-vertify-btn">
            <svg focusable="false" class="zl-vertify-right" data-icon="double-right" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896"><path d="M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"></path></svg>
            <svg focusable="false" class="zl-vertify-checked" data-icon="check" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896"><path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path></svg>
        </div>
    </div>
</template>

<script>

export default {
    data(){
        return {
        }
    },
    methods:{
        init() {
            var resultData = [];
            var $ = function (selector) {
                    return document.querySelector(selector);
                },
                box = $(".zl-vertify-box"),
                bg = $(".zl-vertify-bg"),
                text = $(".zl-vertify-text"),
                btn = $(".zl-vertify-btn"),
                success = false,
                distance = box.offsetWidth - btn.offsetWidth;
            
            let that = this;
            var successF = function(t_result){
                text.innerHTML = "验证通过";
                box.classList.remove('zl-vertify-status-base');
                box.classList.add('zl-vertify-status-success');
                success = true;
                btn.onmousedown = null;
                document.onmousemove = null;
                that.$emit('onVertifyDone',{
                    code1:resultData,
                    code2:t_result
                })
            }
            var resetF = function(){
                text.innerHTML = "请快速拖动滑块！";
                box.classList.remove('zl-vertify-status-success');
                box.classList.add('zl-vertify-status-base');
                success = false;
                btn.style.left = 0;
                bg.style.width = 0;
                btn.style.transition = "left 1s ease";
                bg.style.transition = "width 1s ease";
                resultData = [];
            }
            btn.onmousedown = function (e) {
                btn.style.transition = "";
                bg.style.transition = "";
                e = e || window.event;
                var downX = e.clientX;
                var downY = e.clientY;
                var downTime = new Date().getTime();
                document.onmousemove = function (e) {
                    e= e || window.event;
                    var moveX = e.clientX;
                    var moveY = e.clientY;
                    var offsetX = moveX - downX;
                    var offsetY = moveY - downY;
                    console.log(offsetX + ',' + offsetY)
                    if (offsetX > distance) {
                        offsetX = distance;
                    } else if (offsetX < 0) {
                        offsetX = 0;
                    }
                    else{
                        var c_time = new Date().getTime();
                        resultData.push(offsetX + ',' + offsetY + ',' + (c_time - downTime));
                    }
                    btn.style.left = offsetX + "px";
                    bg.style.width = offsetX + "px";
                    if (offsetX == distance) {
                        var t_result = _encode(JSON.stringify(resultData));
                        // console.log(t_result);
                        // console.log(t_result.length);
                        if(t_result.length > 5000){
                            resetF()
                        }
                        else{
                            successF(t_result)
                        }
          
                        
                    }
                }
                document.onmouseup = function () {
                    if (success) {
                        return;
                    } else {
                        btn.style.left = 0;
                        bg.style.width = 0;
                        btn.style.transition = "left 1s ease";
                        bg.style.transition = "width 1s ease";
                    }
                    document.onmousemove = null;
                    document.onmouseup = null;
                }
            }

            //--- base64加密
            var _PADCHAR = "="
                , _ALPHA = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"

            function _getbyte(s, i) {
                var x = s.charCodeAt(i);
                if (x > 255) {
                    throw "DOM Exception 5"
                }
                return x
            }
            function _encode(s) {
                if (arguments.length !== 1) {
                    throw "SyntaxError"
                }
                s = String(s);
                var i, b10, x = [], imax = s.length - s.length % 3;
                if (s.length === 0) {
                    return s
                }
                for (i = 0; i < imax; i += 3) {
                    b10 = (_getbyte(s, i) << 16) | (_getbyte(s, i + 1) << 8) | _getbyte(s, i + 2);
                    x.push(_ALPHA.charAt(b10 >> 18));
                    x.push(_ALPHA.charAt((b10 >> 12) & 63));
                    x.push(_ALPHA.charAt((b10 >> 6) & 63));
                    x.push(_ALPHA.charAt(b10 & 63))
                }
                switch (s.length - imax) {
                    case 1:
                        b10 = _getbyte(s, i) << 16;
                        x.push(_ALPHA.charAt(b10 >> 18) + _ALPHA.charAt((b10 >> 12) & 63) + _PADCHAR + _PADCHAR);
                        break;
                    case 2:
                        b10 = (_getbyte(s, i) << 16) | (_getbyte(s, i + 1) << 8);
                        x.push(_ALPHA.charAt(b10 >> 18) + _ALPHA.charAt((b10 >> 12) & 63) + _ALPHA.charAt((b10 >> 6) & 63) + _PADCHAR);
                        break
                }
                return x.join("")
            }
        }
    },
    mounted(){
        this.init();
    },
    components:{
    },
    watch:{

    }
};
</script>

<style lang="less" scoped>
.zl-vertify-status-base{
    background-color: #e8e8e8;
    color: #8d959b;
}

.zl-vertify-status-base .zl-vertify-btn{
    background-color: #fff;
    color: #666;
    cursor: pointer;
}

.zl-vertify-status-success{
    color: #fff;
}
.zl-vertify-status-success .zl-vertify-bg{
    border-radius: 2px 0 0 2px;
}
.zl-vertify-status-success .zl-vertify-btn{
    background-color: lightgreen;
    color: #fff;
    font-size: 18px;
    border: none;
    border-radius: 0 2px 2px 0;

    cursor: pointer;
}
.zl-vertify-status-success .zl-vertify-right{
    display: none;
}

.zl-vertify-status-base .zl-vertify-checked{
    display: none;
}

.zl-vertify-box 
{
    width: 300px;
    height: 40px;
    line-height: 40px;
    border-radius: 2px;
    position: relative;
    margin: 0 auto;
}

.zl-vertify-bg {
    width: 40px;
    height: 100%;
    border-radius: 2px;
    background: lightgreen;
    position: absolute;
}

.zl-vertify-text {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    user-select: none;
}

.zl-vertify-btn {
    width: 40px;
    height: 40px;
    font-size: 18px;
    border-radius: 2px;
    position: absolute;
    border: 1px solid #ccc;
    text-align: center;
    user-select: none;
}
</style>
